import React from 'react';
import { Section } from './ui/Section';
import { useMetaPixelViewTracking, trackEvent } from '../utils/metaPixel';
export function Pricing() {
  // Track when pricing section is viewed
  useMetaPixelViewTracking('pricing', {
    content_category: 'pricing',
    content_type: 'product'
  });
  const baseFeatures = ['6 Tomos PDF (300 páginas)', '6 Bonos de implementación', 'Acceso inmediato', 'PDF optimizado para móvil', 'Garantía 7 días'];
  const completeFeatures = [...baseFeatures, '🔥 Zumba Business OS™ completo', '🔥 4 contratos legales firmables', '🔥 20 creativos Canva editables', '🔥 5 guiones de vídeo', '🔥 48 fichas imprimibles', '🔥 Plan 30 Días Sin Pensar'];
  const handlePackClick = (packName: string, price: string) => {
    trackEvent('InitiateCheckout', {
      content_name: packName,
      value: parseFloat(price),
      currency: 'EUR'
    });
  };
  return <Section id="pricing" variant="alt" data-id="element-207">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-12 text-brand-title" data-id="element-208">
        💰 ELIGE TU PACK
      </h2>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-8" data-id="element-209">
        {/* Base Pack */}
        <div className="bg-white border-[1.5px] border-brand-border rounded-2xl p-8 shadow-card hover:shadow-violet-glow transition-all" data-id="element-210">
          <div className="bg-brand-cardPeach rounded-xl p-4 mb-6 -mx-8 -mt-8 mb-6" data-id="element-211">
            <div className="flex items-center gap-2" data-id="element-212">
              <span className="text-3xl" data-id="element-213">🥉</span>
              <div data-id="element-214">
                <h3 className="font-heading text-xl font-bold text-brand-text tracking-wide" data-id="element-215">
                  PACK BASE
                </h3>
              </div>
            </div>
          </div>

          <p className="font-body text-brand-textMuted mb-6 text-sm" data-id="element-216">
            El sistema completo para enseñar mejor desde hoy.
          </p>

          <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-217">
            ← Scroll to see full table →
          </div>

          <div className="overflow-x-auto mb-6" data-id="element-218">
            <table className="w-full min-w-[280px] border-collapse bg-brand-card/30 rounded-xl overflow-hidden border border-brand-border" data-id="element-219">
              <thead data-id="element-220">
                <tr className="border-b border-brand-border" data-id="element-221">
                  <th className="text-left p-3 font-heading font-bold text-brand-text text-sm tracking-wide uppercase" data-id="element-222">
                    ✅ Incluye
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-223">
                {baseFeatures.map((feature, i) => <tr key={i} className="border-b border-brand-border/30 last:border-0" data-id="element-224">
                    <td className="p-3 font-body text-brand-text text-sm flex items-start gap-2" data-id="element-225">
                      <span className="text-brand-success shrink-0" data-id="element-226">✅</span>
                      <span data-id="element-227">{feature}</span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center mb-6" data-id="element-228">
            <div className="font-body text-brand-textMuted text-sm mb-1 line-through" data-id="element-229">
              Valor real: 83,94€
            </div>
            <div className="font-display text-4xl font-black text-brand-title mb-4" data-id="element-230">
              17,90€
            </div>
          </div>

          <a href="https://digipromarket.com/cart/56520042512710:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Pack Base', '17.90')} className="font-heading w-full bg-gradient-gold hover:bg-brand-ctaHover text-white font-bold text-lg py-4 px-6 rounded-2xl transition-colors text-center block shadow-gold-glow mb-4 tracking-wide" data-id="element-231">
            🚀 QUIERO EL PACK BASE
          </a>

          <div className="text-center space-y-1 text-xs text-brand-textMuted tracking-wide" data-id="element-232">
            <div data-id="element-233">⚡ Acceso Inmediato</div>
            <div data-id="element-234">💳 Pago Único</div>
            <div data-id="element-235">🛡️ Garantía 7 Días</div>
          </div>
        </div>

        {/* Complete Pack */}
        <div className="bg-white border-[2.5px] border-brand-title rounded-2xl p-8 shadow-gold-glow-lg relative transform md:-translate-y-4" data-id="element-236">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-gold text-white font-heading font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap shadow-gold-glow tracking-wider" data-id="element-237">
            ⭐ MÁS POPULAR
          </div>

          <div className="bg-gradient-gold rounded-xl p-4 mb-6 -mx-8 -mt-8 mb-6" data-id="element-238">
            <div className="flex items-center gap-2" data-id="element-239">
              <span className="text-3xl" data-id="element-240">🥇</span>
              <div data-id="element-241">
                <h3 className="font-heading text-xl font-bold text-white tracking-wide" data-id="element-242">
                  PACK COMPLETO
                </h3>
              </div>
            </div>
          </div>

          <p className="font-body text-brand-textMuted mb-6 text-sm" data-id="element-243">
            Todo el Pack Base + el Zumba Business OS™
          </p>

          <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-244">
            ← Scroll to see full table →
          </div>

          <div className="overflow-x-auto mb-6" data-id="element-245">
            <table className="w-full min-w-[280px] border-collapse bg-brand-card/30 rounded-xl overflow-hidden border border-brand-title/30" data-id="element-246">
              <thead data-id="element-247">
                <tr className="border-b border-brand-title/30" data-id="element-248">
                  <th className="text-left p-3 font-heading font-bold text-brand-text text-sm tracking-wide uppercase" data-id="element-249">
                    ✅ Incluye
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-250">
                {completeFeatures.map((feature, i) => <tr key={i} className="border-b border-brand-border/30 last:border-0" data-id="element-251">
                    <td className="p-3 font-body text-brand-text text-sm flex items-start gap-2" data-id="element-252">
                      <span className="text-brand-success shrink-0" data-id="element-253">✅</span>
                      <span data-id="element-254">{feature}</span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center mb-6" data-id="element-255">
            <div className="font-body text-brand-textMuted text-sm mb-1 line-through" data-id="element-256">
              Valor real: 147,94€
            </div>
            <div className="font-display text-5xl font-black text-brand-title mb-4" data-id="element-257">
              22,90€
            </div>
          </div>

          <a href="https://digipromarket.com/cart/56520077934918:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Pack Completo', '22.90')} className="font-heading w-full bg-gradient-gold hover:bg-brand-ctaHover text-white font-bold text-lg py-4 px-6 rounded-2xl transition-colors text-center block shadow-gold-glow mb-4 tracking-wide" data-id="element-258">
            🚀 QUIERO EL PACK COMPLETO
          </a>

          <div className="text-center space-y-1 text-xs text-brand-textMuted tracking-wide" data-id="element-259">
            <div data-id="element-260">⚡ Acceso Inmediato</div>
            <div data-id="element-261">💳 Pago Único</div>
            <div data-id="element-262">🛡️ Garantía 7 Días</div>
          </div>
        </div>
      </div>

      <div className="bg-white border border-brand-border rounded-2xl p-6 max-w-2xl mx-auto text-center shadow-card" data-id="element-263">
        <p className="font-body text-brand-text font-medium" data-id="element-264">
          💡 Por solo 5€ más tienes el sistema completo con todo ya creado. La
          gran mayoría elige este.
        </p>
      </div>
    </Section>;
}